// MiliSecondsFormatFilter
export default function MiliSecondsFormatFilter() {
  return function(ms) {
    if (!isNaN(ms)) {
      const msInHour = 3600000;
      const msInMinute = 60000;
      const msInSecond = 1000;
      //need to put logic for adding 0 infront somewhere else
      //millisecond conversion needs to be done somewhere else

      let hours = Math.floor(ms / msInHour);
      hours = hours > 9 ? hours : '0' + hours;
      let minutes = Math.floor((ms % msInHour) / msInMinute);
      minutes = minutes > 9 ? minutes : '0' + minutes;
      let seconds = Math.floor(((ms % msInHour) % msInMinute) / msInSecond);
      seconds = seconds > 9 ? seconds : '0' + seconds;
      return hours + 'h ' + minutes + 'm ' + seconds + 's ';
    }
  };
}
